import { Controller } from "@hotwired/stimulus"

// Contenedor de productos diferido de la tienda (.store-lazy, content-visibility).
// Ver storefront_catalog.md → Restore de la tienda
export default class extends Controller {
  // turbo:before-cache: deja el alto medido (sin padding ni borde) como reserva inline, porque el snapshot clonado no
  // recuerda tamaños, y vuelve a diferir el contenedor si un chip lo dibujó (sticky-nav)
  keepSize() {
    const style = getComputedStyle(this.element)
    const edges = ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"]
      .reduce((sum, property) => sum + (parseFloat(style[property]) || 0), 0)
    const height = this.element.getBoundingClientRect().height - edges
    if (height > 0) this.element.style.containIntrinsicBlockSize = `auto ${Math.round(height)}px`
    this.element.style.contentVisibility = ""
  }
}
